import api from 'services/config/api';

export const captchaRequest = async (token: string) => {
  return await api.post<boolean>(`/captcha?token=${token}`);
};
